import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Quality } from "@/components/site/Quality";
import { Sustainability } from "@/components/site/Sustainability";
import { Grades } from "@/components/site/Grades";
import { Products } from "@/components/site/Products";
import { Properties } from "@/components/site/Properties";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { RequestsAdmin } from "@/components/site/RequestsAdmin";
import { Newsletter } from "@/components/site/Newsletter";
import { WelcomePromo } from "@/components/site/WelcomePromo";
import { LogoIntro } from "@/components/site/LogoIntro";
import { Faq } from "@/components/site/Faq";
import { PrivacyPolicy, CookiePolicy, ScrollToTop } from "@/components/site/Legal";
import { LangProvider } from "@/i18n";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.3, anchors: { offset: -80 } });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);

  return (
    <LangProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
        <Route path="/richieste" element={<RequestsAdmin />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route
          path="*"
          element={
            <div className="App bg-[#FBF9F5] text-[#1C1917]">
              <Header />
              <LogoIntro />
              <main>
                <Hero />
                <Marquee />
                <Quality />
                <Sustainability />
                <Grades />
                <Products />
                <Properties />
                <Faq />
                <Contact />
                <Newsletter />
              </main>
              <WelcomePromo />
              <Footer />
            </div>
          }
        />
        </Routes>
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
